// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-content .image-container{border:1px solid #f7f7f7}.image-content .image-container .ph{width:500px}.image-content .image-container .ph .ph-image{max-width:100%;max-height:100%}.image-content .image-container .hide{display:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
